"use client";

import { useState } from "react";
import "./MemberList.css";

const INITIAL_VISIBLE_COUNT = 4;

export default function MemberList() {
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);
  const [followed, setFollowed] = useState(new Set());


  const toggleExpand = () =>
    setVisibleCount(expanded ? INITIAL_VISIBLE_COUNT : allMembers.length);

  const toggleFollow = (id) =>
    setFollowed((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  return (
    // <div className="ml-card">
    //   <div className="ml-header">
    //     <h3 className="ml-title">You may be interested in</h3>
    //     <button className="ml-viewall" onClick={toggleExpand}>
    //       {expanded ? "View less" : "View all"}
    //     </button>
    //   </div>

    //   <div className="ml-list">
    //     {members.map((m) => {
    //       const isFollowing = followed.has(m.id);
    //       return (
    //         <div key={m.id} className="ml-row">
    //           <img className="ml-avatar" src={m.avatar} alt={m.name} />
    //           <div className="ml-meta">
    //             <div className="ml-name">{m.name}</div>
    //             <div className="ml-titleline">{m.title}</div>
    //           </div>
    //           <button
    //             className={`ml-follow ${isFollowing ? "is-following" : ""}`}
    //             onClick={() => toggleFollow(m.id)}
    //             aria-pressed={isFollowing}
    //           >
    //             {isFollowing ? "Following" : "Follow"}
    //           </button>
    //         </div>
    //       );
    //     })}
    //   </div>
    // </div>
    <></>
  );
}
